<div class="modal-header">
    <h3 class="modal-title">{{ 'ERROR.TITEL' | translate }}</h3>
</div>
<div class="modal-body dl-foutmelding">
    <p class="dl-foutmelding__tekst">{{ melding }}</p>
</div>
<div class="modal-footer">
    @if (vraag) {
        <button class="btn btn-info" (click)="sluit(true)">{{ 'ALGEMEEN.JA' | translate }}</button>
        <button class="btn btn-secondary" (click)="sluit(false)">{{ 'ALGEMEEN.NEE' | translate }}</button>
    } @else {
        <button class="btn btn-info" (click)="sluit()">{{ 'ALGEMEEN.OK' | translate }}</button>
    }
</div>
